import { render, staticRenderFns } from "./XeroTenants.vue?vue&type=template&id=9abf7700&"
import script from "./XeroTenants.vue?vue&type=script&lang=js&"
export * from "./XeroTenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports